<template>
  <div class="notifications">
    <div id="intro" class="notifications parallaxe">
      <parallax>
        <div id="bg1" data-depth="0.15"><img class="" src="@/assets/images/montagnes.png" alt="" title="" /></div>
        <div id="bg2" data-depth="0.3"><img class=""  src="@/assets/images/rayons.png" alt="" title="" /></div>
        <div id="bg4" data-depth="0.1"><img class=""  src="@/assets/images/colines.png" alt="" title="" /></div>
        <div id="bg3" data-depth="0.6"><img class=""  src="@/assets/images/papillons.png" alt="" title="" /></div>
        <div id="front-1" data-depth="0.2"></div>
      </parallax>
    </div>

    <div class="grid-container content-page notifications">
      <div class="grid-x grid-margin-x center">

        <div class="small-12 cell">

        <div v-if="currentUser.account_type === 'child'">
          <title-page attrpage="Agenda et Notifications" baseline="Retrouve ici l’historique de tes rendez-vous, évènements et l’actualité de ta communauté ">Suivi des rendez-vous et évènements</title-page>
        </div>
        <div v-if="currentUser.account_type === 'parent'">
          <title-page attrpage="Agenda et Notifications" :baseline="`Retrouvez ici l'historique des rendez-vous, évènements et actualités de la communauté de ${childName}`">Suivi des rendez-vous et évènements</title-page>
        </div>
        <div v-if="currentUser.account_type === 'relative'">
          <title-page attrpage="Agenda et Notifications" :baseline="`Retrouvez ici l'historique de votre compte et l'actualité de la communauté de ${childName}`">Suivi des évènements et actualités</title-page>
        </div>

        </div>

        <div class="small-12 medium-12 large-6 large-offset-3 cell filtre-type">
          <span>Trier par : </span>
          <pastille type-item="tous" :active="category === ''" @click="e => selectCategory('')"></pastille>
          <pastille v-if="accountType !== 'relative'" type-item="date" :active="category === 'date'" @click="e => selectCategory('date')"></pastille>
          <pastille type-item="alerte" :active="category === 'alerte'" @click="e => selectCategory('alerte')"></pastille>

          <pastille v-if="accountType === 'child'" type-item="badge" :active="category === 'badge'" @click="e => selectCategory('badge')"></pastille>

          <pastille type-item="message" :active="category === 'message'" @click="e => selectCategory('message')"></pastille>
        </div>

        <div class="small-12 cell">
          <div class="timeline">
            <div class="dot end"></div>

            <item-notif v-for="(notif, i) in filteredNotifications" :notification="notif" :direction="i%2 == 0 ? 'right' : 'left'"></item-notif>

            <div class="dot start"></div>
            <!-- <div class="beginning">Départ le 25 septembre 2018</div> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions, mapGetters } from 'vuex'
  import ItemNotif from '@/components/ItemNotif'
  import Pastille from '@/components/Pastille'
  import TitlePage from '@/components/TitlePage'
  import Bouton from '@/components/Bouton'
  import BadgesData from '@/datas/badges'

  const badgesIds = Object.keys(BadgesData).map(id => `badge_${id}`)
  let notifications_types = {
    date: ['appointment_reminder', 'child_appointment_reminder'],
    alerte: ['account_creation', 'child_account_creation', 'sub_account_creation'],
    badge: badgesIds,
    message: [],
  }

  export default {
    components: { Pastille, ItemNotif, TitlePage, Bouton },
    data() {
      return {
        category: ""
      }
    },
    computed: {
      ...mapActions(['resetNotificationsCount']),
      ...mapGetters(['accountType','childName']),
      currentUser() {
        return this.$store.state.me
      },
      notifications() {
        return this.$store.state.notifications.slice().reverse();
      },
      filteredNotifications() {
        if (this.category === "") {
          return this.notifications
        }

        return this.notifications.filter(e => {
          return notifications_types[this.category].indexOf(e.notification_type) !== -1
        })
      }
    },
    mounted() {
      this.resetNotificationsCount();
    },
    methods: {
      selectCategory (cat) {
        this.category = cat
      }
    }
  }
</script>
